import React from 'react'
import st from './CallStatistic.module.scss'
import { formatDuration } from '../CallAnalytics'

const CallStatistic = ({
  name,
  details,
  callColors,
  index,
  sortBy,
  translate,
}) => {
  const totalClientCalls =
    details?.incoming_calls?.quantity_calls +
    details?.outgoing_calls?.quantity_calls
  const totalClientDuration =
    details?.incoming_calls?.duration_seconds +
    details.outgoing_calls?.duration_seconds
  const incomingPercentage =
    (details?.incoming_calls?.quantity_calls / totalClientCalls) * 100
  const outgoingPercentage =
    (details?.outgoing_calls?.quantity_calls / totalClientCalls) * 100

  const colorIndex = index % callColors?.length
  const color = callColors[colorIndex]?.color

  return (
    <div className={st.statistic}>
      <div className={st.statisticHeader}>{name}</div>
      <div className={st.statisticType}>
        <div>{translate?.incoming}</div>
        <div className={st.verticalSeparator}></div>
        <div>{translate?.outgoing}</div>
      </div>
      <div className={st.callInfo}>
        <div className={st.progressBarAndTotal}>
          <div className={st.progressBar}>
            <div
              className={st.incomingBar}
              style={{
                width: `${incomingPercentage}%`,
                backgroundColor: color || '#55B1F3',
              }}
            >
              {sortBy === 'quantity'
                ? details.incoming_calls.quantity_calls
                : formatDuration(details.incoming_calls.duration_seconds)}
            </div>
            <div
              className={st.outgoingBar}
              style={{ width: `${outgoingPercentage}%` }}
            >
              {sortBy === 'quantity'
                ? details.outgoing_calls.quantity_calls
                : formatDuration(details.outgoing_calls.duration_seconds)}
            </div>
          </div>
          <div className={st.totalCalls}>
            {sortBy === 'quantity'
              ? totalClientCalls
              : formatDuration(totalClientDuration)}
          </div>
        </div>

        <div className={st.duration}>
          <div>
            {translate?.duration_label}:{' '}
            <span>
              {formatDuration(
                details.incoming_calls.duration_seconds +
                  details.outgoing_calls.duration_seconds,
              )}
            </span>
          </div>
          <div className={st.totalCallsMobile}>
            {sortBy === 'quantity'
              ? totalClientCalls
              : formatDuration(totalClientDuration)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CallStatistic
